<template>
    <div>
        <div class="blackBg animate__animated animate__slideInLeft">
            <div class="cardTit">
                <span class="teamName">{{$route.params.name ? $route.params.name : '精彩视频'}}</span>
            </div>
            <div class="lesson">
                <div class="bigVideo" v-if="!this.$route.query.type">
                    <img :src="$route.query.img" alt="">
                    <div class="message">
                        <p class="list-item-tit-msg">{{ $route.query.name }}</p>
                        <p class="list-item-tit-date">{{ $global.formatDate(new Date($route.query.date), 'yyyy-MM-dd HH:mm:ss', true) }}</p>
                    </div>
                </div>
                <div class="videoList">
                    <div class="item" v-for="(item,index) in videoList" :key="item.id">
                        <span class="number">{{index+1}}</span>
                        <img v-if="!$route.query.type"
                             :src="item.snapshot ? item.snapshot : require('@/assets/img/updateImg/exerciseBg.png')" alt="">
                        <video v-else :src="item.src"></video>
                        <div class="message">
                            <p class="list-item-tit-msg">{{item.label}}</p>
                        </div>
                    </div>
                    <div v-if="!videoList.length" class="cardBg" style="height: 26vw;text-align: center;font-size: 26px;line-height: 26vw">暂无数据</div>
                </div>
                <div class="footer" v-if="videoList.length && !this.$route.query.type">
                    <span class="prev" @click="changePage(-1)">上一页</span>
                    <span class="next" @click="changePage(1)">下一页</span>
                    <span class="page"><i>{{page}}</i>/{{totalPages}}</span>
                </div>
            </div>
        </div>
        <div class="myVideo" v-show="videoHidden">
            <video id="myVideo" ref="myPlayer" :src="videoSrc" :controls="videoControls"  allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></video>
        </div>
    </div>
</template>

<script>
    export default {
        name: "videoList",
        data() {
            return {
                teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
                includeGK: false,//是否包含守门员
                videoList: [],
                page: 1,//页码
                totalPages: 0,//总页数
                videoSrc: "",//原始视频路径
                _endTime: "",//结束时间
                videoHidden: false,//视频是否显示
                videoControls: false,//视频控制条是否显示
            }
        },
        computed: {
            lookCommandFn() {
                return this.$store.state.lookCommand;
            },
        },
        watch: {
            videoHidden: {
                handler(val, old) {
                    if (!val) {
                        this.$parent.$parent.imgAi(this.$imgJson.taskAiImgArr);
                        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("您可以继续播放或者返回！"), true, false)
                    }
                },
                deep: true
            },
            page: {
                handler(val, old) {
                    this.getVideoList();
                },
                deep: true
            },
            lookCommandFn: {
                async handler(val, old) {
                    let videoList = this.videoList;
                    let prevPage = this.$aiJson.prevPage;
                    let nextPage = this.$aiJson.nextPage;
                    let flag = 0;
                    let speak = '';
                    //数字号判断
                    if (!flag) {
                        for (let item = 0; item < videoList.length; item++) {
                            if (eval('/' + this.$aiJson.itemNum[item] + '号' + '/gi').test(val)) {
                                flag = 1;
                                //全屏播放视频
                                speak = 'detail';

                                setTimeout(() => {
                                    this.playVideo(this.videoList[item]);
                                }, 3000)
                                break;
                            } else {
                                flag = 0;
                            }
                        }
                    }

                    //上一页判断
                    if (!flag) {
                        for (let item = 0; item < prevPage.length; item++) {
                            if (eval('/' + prevPage[item] + '/gi').test(val)) {
                                flag = 1;
                                speak = this.page != 1 ? '上一页的视频' : '';
                                this.changePage(-1);
                                break;
                            } else {
                                flag = 0;
                            }
                        }
                    }
                    //下一页判断
                    if (!flag) {
                        for (let item = 0; item < nextPage.length; item++) {
                            if (eval('/' + nextPage[item] + '/gi').test(val)) {
                                flag = 1;
                                speak = this.page != this.totalPages ? '下一页的视频' : '';
                                this.changePage(1);
                                break;
                            } else {
                                flag = 0;
                            }
                        }
                    }
                    if (flag) {
                        if (speak != '') {
                            if (speak == 'detail') {
                                //全屏播放视频
                                this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息

                            } else {
                                // this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl('这是本视频的精彩视频短片,您请查收！'), true, false)
                            }
                        }
                    } else {
                        this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息
                    }
                },
                deep: true
            },
        },
        mounted() {
            if (this.$route.query.type) { //俱乐部精彩瞬间
                this.videoList = [
                    {
                        label: '2020关心-慰问医生',
                        src: 'https://acme-internal.oss-cn-beijing.aliyuncs.com/%E5%9B%BD%E5%AE%89/%E5%9B%BD%E5%AE%89%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91/2020%E5%85%B3%E5%BF%83-%E6%85%B0%E9%97%AE%E5%8C%BB%E7%94%9F.mp4'
                    },
                    {
                        label: '2021北京国安一线队宣传片',
                        src: 'https://acme-internal.oss-cn-beijing.aliyuncs.com/%E5%9B%BD%E5%AE%89/%E5%9B%BD%E5%AE%89%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91/2021%E5%8C%97%E4%BA%AC%E5%9B%BD%E5%AE%89%E4%B8%80%E7%BA%BF%E9%98%9F%E5%AE%A3%E4%BC%A0%E7%89%872021.04.mp4'
                    }
                ];
                this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是俱乐部精彩视频短片,您请查收！"), true, false)
                this.videoControls = true;
            } else { //视频剪辑片段
                this.$store.state.pageParams.id = this.$route.query.id;
                this.$store.state.pageParams.page = this.$route.query.page;
                this.getVideoList();
            }
        },
        methods: {
            getVideoList() {
                let data = {
                    paging: true,
                    pageSize: this.$route.query.type ? 8 : 4,
                    page: this.page,
                    videoId: this.$route.query.id,
                }
                this.$server.getVideoClipsList(data)
                    .then(res => {
                        this.videoList = res.data.list;
                        this.totalPages = res.data.pages;
                        this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是本视频的精彩视频短片,您请查收！"), true, false)
                    })
            },
            //翻页
            changePage(type) {
                if (type > 0) {
                    if (this.page == this.totalPages) {
                        //当前是最后一页
                        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl(this.$aiJson.playVoice.lastPage), true, false)
                    } else {
                        this.page++
                    }
                } else {
                    if (this.page == 1) {
                        //当前是第一页
                        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl(this.$aiJson.playVoice.firstPage), true, false)
                    } else {
                        this.page--
                    }
                }
            },

            //初始化视频
            infoVideo() {
                // //初始化视频
                // !(this._endTime) ? this.$refs.myPlayer.removeEventListener('timeupdate') : '';
                this.$refs.myPlayer.addEventListener("timeupdate", this.timeupdate);
                this.$refs.myPlayer.addEventListener('ended', () => { //结束
                    this.videoHidden = false;
                }, false);
            },
            //全屏播放视频
            playVideo(item) {
                console.log(item)
                this.videoSrc = item.src ? item.src : item.url;
                this.infoVideo();
                this._endTime = null;
                this.$refs.myPlayer.currentTime = 0;

                setTimeout(() => {
                    this.videoHidden = true;
                    this.$refs.myPlayer.play();
                })

            },
            timeupdate() {
                //因为当前的格式是带毫秒的float类型的如：12.231233，所以把他转成String了便于后面分割取秒
                var time = this.$refs.myPlayer.currentTime + "";
                var ts = time.substring(0, time.indexOf("."));
                if (ts == this._endTime) {
                    this.$refs.myPlayer.pause();
                    this.videoHidden = false;
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .myVideo {
        background: rgba(42, 44, 59, 0.7);
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: 100000;
        text-align: center;

        video {
            width: 100%;
            /*height: 100%;*/
        }
    }

    .cardTit {
        margin-top: 2vw;
        font-size: 30px;
        box-sizing: border-box;
        position: relative;
    }

    .bigVideo {
        margin-top: 0.5vw;
        width: calc(50% - 1vw);
        float: left;
        background: rgba(14, 14, 14, 0.7);
        height: 26vw;
        margin-right: 1vw;
        img {
            /*height: 100%;*/
            width: 100%;
            height: 19vw;
        }

        video {
            width: 100%;
            height: 9vw;
        }

        .message {
            color: rgba(255, 255, 255, .6);
            font-size: 22px;
            width: 100%;
            padding: .5vw 1vw;
            box-sizing: border-box;

            .list-item-tit-msg {
                font-size: 26px;
                line-height: 3vw;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #fff;
            }
        }
    }

    .videoList {
        width: 50%;
        color: #fff;
        margin-top: 0.5vw;
        min-height: 28vw;
        float: left;

        .item {
            width: calc((100% - (1vw * 2)) / 2);
            float: left;
            margin-left: 1vw;
            margin-bottom: 1.5vw;
            position: relative;
            overflow: hidden;
            height: 12.25vw;
            background: rgba(14, 14, 14, 0.7);
            border: 2px solid rgba(255, 255, 255, 0.1);
            box-sizing: border-box;

            &:nth-child(4n) {
                margin-right: 0;
            }

            img {
                height: 9.5vw;
                width: 100%;
            }

            video {
                width: 100%;
                height: 9vw;
            }

            .number {
                border: 2px solid rgba(255, 255, 255, 0.3);
                width: 2vw;
                height: 2vw;
                background-color: var(--primary-color);
                border-radius: 50%;
                text-align: center;
                line-height: 1.8vw;
                font-size: 34px;
                position: absolute;
                font-family: akrobatBold;
                top: .2vw;
                left: .2vw;
            }

            .message {
                color: rgba(255, 255, 255, .6);
                font-size: 22px;
                width: 100%;
                padding: .3vw 1vw;
                box-sizing: border-box;

                .list-item-tit-msg {
                    line-height: 1.5vw;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #fff;
                }
            }
        }
    }
</style>
